/**
 * Video poster-frame helper.
 *
 * A native `<video preload="metadata">` loads metadata but most browsers do
 * NOT paint the first frame until the element seeks — so an un-hinted video
 * renders as an opaque black tile until the user presses play. Appending a
 * `#t=0.1` media fragment makes the browser seek to 0.1s and paint that frame
 * as the poster, for free, with no JS and no server-side thumbnail.
 *
 * This is the single source of truth for that fragment: every native-video
 * thumbnail/first-frame surface calls `withPosterFragment(src)` on its `src`
 * instead of re-deriving the fragment inline (which is how the "black tile"
 * bug got copy-pasted across ~8 renderers).
 *
 * Only apply to a URL you render for its first frame. It is a no-op when the
 * URL already carries a fragment (so an explicit `#t=` is never doubled) and
 * returns `undefined` for a nullish src so callers can spread it straight onto
 * a `src` attribute.
 */
export function withPosterFragment(
  src: string | null | undefined,
): string | undefined {
  if (!src) return undefined;
  return src.includes('#') ? src : `${src}#t=0.1`;
}
